/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatconverterdescription2Inputs */

const en_formatconverterdescription2 = /** @type {(inputs: Formatconverterdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI rearranges your image for every social media format.`)
};

const de_formatconverterdescription2 = /** @type {(inputs: Formatconverterdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die KI ordnet dein Bild für jedes Social-Media-Format neu an.`)
};

/**
* | output |
* | --- |
* | "AI rearranges your image for every social media format." |
*
* @param {Formatconverterdescription2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const formatconverterdescription2 = /** @type {((inputs?: Formatconverterdescription2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatconverterdescription2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatconverterdescription2(inputs)
	return de_formatconverterdescription2(inputs)
});
export { formatconverterdescription2 as "formatConverterDescription" }